import { GqlMapEditorGetLayerAllFeaturesParams } from "~/__generated__";
import useMapEditorGetAllLayerFeatures from "~/modules/mapEditor/api/useMapEditorGetAllLayerFeatures";

import useProjectMapEditorScreen_GetProject from "./useProjectMapEditorScreen_GetProject";

/*
We have two separate queries here because they have different caching policies.
- useProjectMapEditorScreen_GetProject > more static data, we keep cached
- useMapEditorGetAllLayerFeatures > updates more often based on filters
*/
export default function useProjectMapEditorScreenData(projectId: string, params: GqlMapEditorGetLayerAllFeaturesParams) {
    const {
        data: allLayerData,
        filterOptions,
        loading: loadingFeatures,
        error: errorFeatures,
    } = useMapEditorGetAllLayerFeatures(projectId, params);

    const {
        projectData,
        functionTypes,
        observationTypes,
        researchTypes,
        layers,
        loading: loadingStatic,
        error: errorStatic,
    } = useProjectMapEditorScreen_GetProject(projectId);

    return {
        allLayerData,
        filterOptions,
        projectData,
        functionTypes,
        observationTypes,
        researchTypes,
        layers,
        loading: loadingFeatures || loadingStatic,
        error: errorFeatures ?? errorStatic,
    };
}
